import React, { useState } from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  AppBar, 
  Toolbar, 
  IconButton, 
  Menu, 
  MenuItem,
  Snackbar,
  Alert,
  Button,
  Avatar
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import RefreshIcon from '@mui/icons-material/Refresh';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Dashboard from './components/Dashboard';
import { useQueryClient } from '@tanstack/react-query';

function App() {
  const queryClient = useQueryClient();
  const [anchorEl, setAnchorEl] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'info'
  });
  
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  
  const handleRefresh = () => {
    queryClient.invalidateQueries();
    setSnackbar({
      open: true,
      message: 'Dashboard data refreshed',
      severity: 'success'
    });
  };
  
  const handleExportCSV = () => {
    setSnackbar({
      open: true,
      message: 'Exporting data as CSV',
      severity: 'info'
    });
    handleMenuClose();
    // CSV export functionality will be implemented here
  };
  
  const handleExportPDF = () => {
    setSnackbar({
      open: true,
      message: 'Exporting dashboard as PDF',
      severity: 'info'
    });
    handleMenuClose();
    // PDF export functionality will be implemented here
  };
  
  const handleSnackbarClose = () => {
    setSnackbar({
      ...snackbar,
      open: false
    });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static">
        <Toolbar>
          <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
            <Avatar 
              src="/images/oe-logo.png" 
              alt="Oliver Energy Logo" 
              sx={{ 
                width: 40, 
                height: 40, 
                mr: 2, 
                bgcolor: 'transparent',
                '& img': {
                  objectFit: 'contain'
                }
              }}
            />
            <Typography variant="h6" component="div">
              Oliver Energy - Example Financial Dashboard
            </Typography>
          </Box>
          <Button 
            color="inherit" 
            startIcon={<RefreshIcon />}
            onClick={handleRefresh}
          >
            Refresh
          </Button>
          <Button 
            color="inherit" 
            startIcon={<DownloadIcon />}
            onClick={handleExportCSV}
          >
            Export CSV
          </Button>
          <IconButton
            color="inherit"
            aria-label="more options"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenuOpen}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleExportCSV}>Export as CSV</MenuItem>
            <MenuItem onClick={handleExportPDF}>Export as PDF</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      <Container maxWidth="xl" sx={{ flexGrow: 1, py: 4 }}>
        <Dashboard />
      </Container>
      
      <Box component="footer" sx={{ py: 2, bgcolor: 'primary.main', color: 'white', mt: 'auto' }}>
        <Container maxWidth="xl">
          <Typography variant="body2" align="center">
            <a href="https://www.olivertriunfo.com/financial-dashboard-power-generation/" style={{ color: 'white', textDecoration: 'none' }}>CLICK HERE to read the article 👉 Building an Effective Financial Dashboard for Power Generation: The Oliver Energy Case Study</a>
          </Typography>
        </Container>
      </Box>
      
      <Snackbar 
        open={snackbar.open} 
        autoHideDuration={6000} 
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default App;
